const playground = {
  title: 'Chat',
  description: 'Test and explore your Brain in real time',
  welcomeMessage: 'Welcome to the Brain Chat!',
  welcomeDescription: 'Here you can interact directly with your Brain. Ask questions, test scenarios and explore the system capabilities.',
  inputPlaceholder: 'Type your message to the Brain...',
  sendMessage: 'Send message',
  noWorkspaceSelected: 'No workspace selected',
  selectWorkspaceFirst: 'Select a workspace to start using the Chat',
  connecting: 'Connecting...',
  connected: 'Connected',
  disconnected: 'Disconnected',
  reconnecting: 'Reconnecting...',
  connectionError: 'Connection error',
  retryConnection: 'Try again',
  chatHistory: 'Chat History',
  clearChat: 'Clear Chat',
  error: 'Error',
  typing: 'Typing...',
  userJoined: '{username} joined the chat',
  userLeft: '{username} left the chat',
  playgroundAI: 'Chat AI',
  you: 'You',

  // Conversation history sidebar (v2)
  sidebar: {
    newChat: 'New conversation',
    search: 'Search conversation…',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Previous 7 days',
    older: 'Older',
    empty: 'No conversations yet',
    noResults: 'No conversations found',
  },

  // PlaygroundView specific
  view: {
    title: 'Chat',
    subtitle: 'Chat with your AI in real time',
    conversation: 'Conversation: ',
    newChat: 'New Chat',
    settings: 'Chat Settings',
    shareConversation: 'Share conversation as PDF',
    emptyStateTitle: 'How can I help you with your project?',
    emptyStateSubtitle: 'Choose a suggestion below or type your own question',
    emptyChatTitle: 'Empty Chat',
    emptyChatSubtitle: 'Send your first message to start the conversation.',
    aiThinking: 'Thinking...',
    selectingAgents: 'Selecting agents...',
    sendButton: 'Send',
    inputPlaceholder: 'Type your message to the AI...',
    keyboardShortcuts: 'Press Enter to send, Shift + Enter for new line',
    noLlmTitle: 'No LLM model configured',
    noLlmDescription: 'To chat in the Chat, configure an LLM model in a Tool, or set a Tool as the organization default model.'
  },

  // Prompt suggestions
  suggestions: {
    projectAnalysis: {
      title: 'Project Analysis',
      description: 'Evaluate strengths, weaknesses and opportunities',
      prompt: 'Perform a detailed analysis of my project, including strengths, weaknesses and improvement opportunities'
    },
    executivePresentation: {
      title: 'Executive Presentation',
      description: 'Create a presentation for stakeholders',
      prompt: 'Create an executive presentation outline about my project for stakeholders, including metrics and next steps'
    },
    projectStory: {
      title: 'Project Story',
      description: 'Create an engaging narrative about the project',
      prompt: 'Tell my project\'s story in an engaging way, highlighting its journey, evolution and market impact'
    },
    competitorAnalysis: {
      title: 'Competitor Analysis',
      description: 'Compare with competition and identify differentiation',
      prompt: 'Develop a comparative analysis of my project\'s main competitors, including differentiation and positioning'
    },
    marketingStrategy: {
      title: 'Marketing Strategy',
      description: 'Develop campaigns and identify ideal channels',
      prompt: 'Suggest a digital marketing strategy for my project, including channels, messages and target audience'
    },
    projectFAQ: {
      title: 'Project FAQ',
      description: 'Generate frequently asked questions with answers',
      prompt: 'Create a list of frequently asked questions (FAQ) about my project with detailed answers for customers'
    }
  },

  // ChatList specific
  chatList: {
    title: 'Chat History',
    description: 'Manage your chat sessions with the Brain',
    newChat: 'New Chat',
    noChatsYet: 'No chats yet',
    createFirstChat: 'Create your first chat or send a message to get started',
    renameChat: 'Rename Chat',
    archiveChat: 'Archive Chat',
    deleteChat: 'Delete Chat',
    deleteConfirmTitle: 'Delete chat?',
    deleteConfirmDescription: 'This action cannot be undone. The chat and all its history will be permanently deleted.',
    chatDeleted: 'Chat deleted successfully',
    chatArchived: 'Chat archived successfully',
    chatRenamed: 'Chat renamed successfully',
    chatCreated: 'New chat created',
    createError: 'Error creating chat',
    renameError: 'Error renaming chat',
    archiveError: 'Error archiving chat',
    deleteError: 'Error deleting chat',
    emptyTitleError: 'Title cannot be empty',
    titleTooLongError: 'Title cannot be longer than 255 characters',
    showFullHistory: 'Show full history',
    chatActions: 'Chat actions',
    messageCount: {
      singular: 'message',
      plural: 'messages'
    },
    activeChats: {
      singular: 'active chat',
      plural: 'active chats'
    },
    timeAgo: 'Now'
  },

  // ChatMessage specific
  message: {
    shareTitle: 'Share message',
    favoriteTitle: 'Favorite message',
    copyTitle: 'Copy message',
    you: 'You',
    aiResponseTitle: 'AI Response - {name}'
  },

  // PlaygroundConfigDialog specific
  config: {
    title: 'Chat Settings',
    loading: 'Loading settings...',
    saving: 'Saving...',
    saved: 'Settings saved',
    savedDescription: 'Chat settings have been successfully updated.',
    reset: 'Reset',
    cancel: 'Cancel',
    save: 'Save',
    tabs: {
      rag: 'RAG & AI',
      ui: 'Interface',
      restrictions: 'Restrictions'
    },
    rag: {
      title: 'RAG and AI Settings',
      similarityThreshold: 'Similarity Threshold',
      maxResults: 'Maximum Results',
      temperature: 'Temperature',
      maxTokens: 'Maximum Tokens',
      systemPrompt: 'System Prompt',
      systemPromptPlaceholder: 'Define the AI behavior and role...'
    },
    ui: {
      title: 'Interface Settings',
      welcomeMessage: 'Welcome Message',
      welcomeMessagePlaceholder: 'Message displayed when user opens the chat...',
      inputPlaceholder: 'Input Placeholder',
      inputPlaceholderPlaceholder: 'Placeholder text for the input field...',
      maxChatHistory: 'Maximum Chat History'
    },
    restrictions: {
      title: 'Restrictions and Limits',
      allowedFileTypes: 'Allowed File Types',
      allowedFileTypesPlaceholder: 'pdf, txt, docx, xlsx...',
      allowedFileTypesHelp: 'Separate file types with commas',
      maxQueryLength: 'Maximum Query Length (characters)',
      rateLimitPerMinute: 'Query Limit per Minute'
    }
  },

  // Error messages
  errors: {
    general: 'An error occurred',
    sendMessage: 'Error sending message',
    loadHistory: 'Error loading chat history',
    loadConfig: 'Error loading settings',
    saveConfig: 'Error saving settings',
    subscriptionRequired: 'Subscription Expired/Exhausted - Add more credits or upgrade your plan to continue chatting.'
  },

  // No workspace state
  no_workspace: {
    title: 'No workspace selected',
    description: 'Select a workspace to start using the Chat'
  },

  // Loading states
  loading: {
    history: {
      title: "Loading history...",
      description: "Retrieving your previous conversations with the AI"
    }
  },

  // Legacy support
  manageChatSessions: 'Manage your chat sessions with the Brain',
  newChat: 'New Chat',
  creatingChat: 'Creating...',
  noChatsYet: 'No chats yet',
  createFirstChat: 'Create your first chat or send a message to get started',
  renameChat: 'Rename Chat',
  archiveChat: 'Archive Chat',
  deleteChat: 'Delete Chat',
  deleteConfirmTitle: 'Delete chat?',
  deleteConfirmDescription: 'This action cannot be undone. The chat and all its history will be permanently deleted.',
  chatDeleted: 'Chat deleted successfully',
  chatArchived: 'Chat archived successfully',
  chatRenamed: 'Chat renamed successfully',
  chatCreated: 'New chat created',
  emptyStateTitle: 'Welcome to Chat!',
  emptyStateDescription: 'Select an existing conversation or send a message to start a new one.',
  emptyChat: 'Empty chat',
  startConversation: 'Send your first message to start the conversation',
  no_agent_selected: "Type your question to get started",
  ai_thinking: "AI is processing your question...",

  // Chat structure
  chat: {
    input_placeholder: 'Type your message to the Brain...',
    send: 'Send',
    stop: 'Stop',
    stopped: 'Response stopped.',
    stopFailed: 'Could not stop the response; it is still running. Try again.',
    waitingRun: 'waiting for the run… {{seconds}} s',
    queued: 'Queued: the agent answers as soon as it finishes what it is doing.',
    traceUnavailable: 'the reasoning behind this answer could not be loaded'
  },

  // Tasks the agent follows after answering (AB#86889)
  backgroundTasks: {
    badge_one: '{{count}} task running',
    badge_other: '{{count}} tasks running',
    title: 'Background tasks',
    noRequest: 'Task without a description',
    cancel: 'Cancel task',
    cancelFailed: 'Could not cancel. Try again.',
    listMarker: 'In progress',
    replyElsewhere: 'A task finished in "{{title}}"',
    replyElsewhereUntitled: 'A task finished in another conversation',
    open: 'Open conversation',
    status: {
      watching: 'Running',
      completing: 'Finishing',
      delivered: 'Done',
      failed_delivery: 'Could not reply',
      cancelled: 'Cancelled',
      expired: 'Expired'
    }
  },

  attachments: {
    add: 'Attach files',
    remove: 'Remove {{name}}',
    tooLarge: 'Files larger than 50 MB were not attached',
    uploadFailed: 'The files could not be attached',
    truncated: 'partial',
    truncatedHint: 'The file is long: the assistant read only its beginning.',
    summarizing: 'summarizing',
    summarizingHint: 'The file is long: the assistant reads its beginning and any part it needs, and a summary of the whole file is being prepared.',
    summarized: 'summarized',
    summarizedHint: 'The file is long: the assistant has a summary of the whole file and reads any part it needs.',
    summaryFailed: 'no summary',
    summaryFailedHint: 'The summary of the whole file could not be prepared. The assistant still reads its beginning and any part it needs.',
    unreadable: 'no text',
    unreadableHint: 'No text could be read from this file (for example, a scanned PDF).',
    open: 'Open {{name}}',
    openFailed: 'The file could not be opened',
    openFailedHint: 'Attachments are kept for 24 hours. If you saved it to the Knowledge, open it in Brain → Files.'
  },

  // MCP Tools discovery
  mcpTools: {
    title: 'MCP Tools',
    openDialog: 'View all MCP tools and configuration',
    tabs: {
      integrations: 'Apps',
      core: 'Core',
      config: 'Connect'
    },
    integrations: {
      empty: 'No tools with MCP operations installed for this workspace.',
      catalogNotePrefix: 'In external connections these operations run through the ',
      catalogNoteMiddle: ' tool, which carries the index of all of them. To expose each operation as its own tool, add ',
      catalogNoteSuffix: ' to the MCP URL.',
      toolCount_one: '{{count}} tool',
      toolCount_other: '{{count}} tools'
    },
    coreGroups: {
      session: 'Session',
      profile: 'Profile',
      brain: 'Brain',
      memory: 'Memory',
      utilities: 'Utilities',
      integrations: 'Tools',
      skills: 'Skills',
      jobs: 'Jobs',
      flows: 'Flows',
      admin: 'Admin (SUPERADMIN / ADMIN)'
    },
    coreTools: {
      session_load: "The start of every conversation: user, organization, AI preferences, and the identity of the workspace — its Soul, Mind index and members.",
      brain_load: "The Brain of the workspace: the Mind and a pointer to the Knowledge — plus the Soul and members of another workspace.",
      mind_get: "One block of the Mind in full, by its key: for the blocks the Brain brings cut or only in the index.",
      facets_load: "The facet vocabulary of the organization, to tag Mind blocks and filter the knowledge search.",
      mind_submit: "Create, update or delete an unlocked block of the Mind (ADMIN). The Soul never changes here.",
      memory_search: "Search what people and agents asked to remember (personal, workspace and organization), as facts with their validity.",
      memory_list: "List the memories of one scope, newest first, with author, origin and validity.",
      memory_submit: "Save, change or forget a memory. Only what the user asked to remember; organization memories are ADMIN only.",
      profile_submit: "Change the user's profile: language, personal AI instructions and the destructive-action confirmation.",
      knowledge_search: "Semantic RAG search across the Brain.",
      knowledge_get: "List the Knowledge documents, read one in full or get a temporary download link.",
      knowledge_submit: "Add, replace, re-tag or delete Knowledge documents — by link, direct upload or content. Deleting asks for confirmation.",
      tools_load: 'Tools available in the workspace: installation name, scope and operations.',
      tools_get: 'Read the schema and rules of operations of one installation, without running them.',
      tools_run: 'Run one operation of one installation. Its description indexes every operation.',
      tools_store: 'Prodgy tool catalog: list, show a template and install.',
      tools_submit: 'Create, update or delete a tool template (SUPERADMIN / ADMIN).',
      skills_load: 'Skills installed for you: name and description. Loaded when the request needs it.',
      web_search: 'Internet search with sources: the free provider first and, if it fails, the paid providers configured by the platform.',
      skills_get: 'Full instructions of one Skill, plus the inventory of its supporting files.',
      skills_resource: 'Read one supporting file of a Skill.',
      skills_run: "Run a Python script shipped with a Skill, in an isolated environment. Only in the Prodgy agent — external agents don't get it.",
      skills_store: 'Skill catalog: list, show, install and uninstall (install and uninstall require ADMIN).',
      skills_submit: 'Submit a Skill package: your own space or the organization catalog.',
      jobs_load: 'Jobs of the workspace: the instruction, the trigger, published or not and last run.',
      jobs_get: 'One job (instruction, trigger, webhook) or one run, with the agent report.',
      jobs_runs: 'Run history of every job, filtered by status, period and job.',
      jobs_submit: 'Create, update, test, publish or delete a job from an instruction, which cites the Skill, and a trigger (organization ADMIN).',
      flows_load: 'Flows of the workspace: published or not, active triggers and last run.',
      flows_get: 'One flow (draft, published version, triggers) or one run, step by step.',
      flows_steps: 'Steps available to build a flow, or how to configure one of them.',
      flows_submit: 'Create, update, test or publish a flow (organization ADMIN).',
      get_mcp_settings: 'Read current MCP server instructions and export rules.',
      update_mcp_settings: 'Update MCP server instructions and export rules.'
    },
    config: {
      oneClickTitle: 'Connect in one click',
      oneClickDescription: 'The editor opens the Prodgy login on the first call; there you authorize and pick the workspace. No token needed.',
      addToCursor: 'Add to Cursor',
      addToVsCode: 'Add to VS Code',
      claudeCodeTitle: 'Claude Code',
      urlTitle: 'Other agents (Claude, ChatGPT and the like)',
      urlDescription: 'Add a custom MCP connector with this URL. The Prodgy login opens the first time.',
      manualTitle: 'Manual setup with a token',
      descriptionPrefix: 'Add this snippet to your MCP client config (',
      descriptionSuffix: ').',
      tokenHintPrefix: 'Generate a token in ',
      tokenHintBold: 'Workspace Settings → API Tokens',
      tokenHintSuffix: '.',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Failed to copy to clipboard'
    }
  },

  // Embed Widget
  embedWidget: {
    title: 'Embed Widget',
    subtitle: 'Embed chat widget for',
    embedButton: 'Embed Widget',
    customize: 'Customize',
    widgetTitle: 'Widget Title',
    width: 'Width (px)',
    height: 'Height (px)',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    embedCode: 'Embed Code',
    iframeDescription: 'Paste this code into your HTML page to embed the chat widget.',
    scriptDescription: 'Add this script to your page for an auto-loading floating chat widget.',
    directUrl: 'Direct URL',
    codeCopied: 'Code copied',
    codeCopiedDescription: 'The embed code has been copied to clipboard.',
    copyFailed: 'Failed to copy'
  }
} as const;

export default playground;
